import { render, staticRenderFns } from "./add-summarize.vue?vue&type=template&id=4c2a32ea"
import script from "./add-summarize.vue?vue&type=script&lang=js"
export * from "./add-summarize.vue?vue&type=script&lang=js"
import style0 from "./add-summarize.vue?vue&type=style&index=0&id=4c2a32ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports